(() => {
  'use strict';
  const key = 'wishlistItem';
  let scheduled = false;

  function readSaved() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string' && item.length > 0))] : [];
    } catch {
      return [];
    }
  }

  try {
    const value = JSON.stringify(readSaved());
    if (localStorage.getItem(key) !== value) localStorage.setItem(key, value);
  } catch {}

  function sync() {
    scheduled = false;
    const handles = new Set(readSaved());
    const removeLabel = document.querySelector('[data-remove-wishlist-label]')?.dataset.removeWishlistLabel;
    document.querySelectorAll('[data-wishlist]').forEach(button => {
      const selected = handles.has(button.dataset.wishlistHandle);
      const label = selected && removeLabel ? removeLabel : window.wishlist?.[selected ? 'added' : 'add'];
      button.classList.toggle('wishlist-added', selected);
      button.setAttribute('aria-pressed', String(selected));
      button.removeAttribute('aria-disabled');
      if (label) {
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      }
      if (button.tagName !== 'BUTTON') {
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
      }
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(counter => {
      const value = String(handles.size);
      if (counter.textContent !== value) counter.textContent = value;
    });
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function init() {
    sync();
    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('[data-wishlist]')) setTimeout(scheduleSync, 0);
    }, true);
    document.addEventListener('keydown', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-wishlist]');
      if (button && button.tagName !== 'BUTTON' && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        button.click();
      }
    });
    ['updatewishlistmail', 'updatepagination'].forEach(name => document.addEventListener(name, scheduleSync));
    window.addEventListener('pageshow', scheduleSync);
    window.addEventListener('storage', event => {
      if (event.key === key || event.key === null) scheduleSync();
    });
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('[data-wishlist]') || node.querySelector('[data-wishlist]'))))) scheduleSync();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
